import {DataFetcher} from '@aboutyou/data-fetcher';
import {useTranslation} from '@aboutyou/i18n';
import {originClick} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import {
  NavigationTree,
  NavigationTreeProps,
} from '../../../features/NavigationTree/NavigationTree';
import {NavigationTreeLoading} from '../../../features/NavigationTree/NavigationTreeLoading';
import {FIRST_PRODUCT_ID_PARAM} from '../../../features/firstProductId/useFirstProductIds';
import {useWishlistTree} from '../hooks/useWishlistTree';

export const WishlistNavigationTree: React.FC<{
  className?: string;
  excludeUrlParams?: string[];
}> = props => {
  const {t} = useTranslation();

  return (
    <DataFetcher
      request={useWishlistTree()}
      Error={() => null}
      Loading={NavigationTreeLoading}
      View={NavigationTree}
      viewProps={{
        ...props,
        trackOriginKey: 'category_tree_side' as originClick,
        testId: 'wishlistNavigationTree',
        'aria-label': t('Wishlist navigation'),
        excludeUrlParams: [
          FIRST_PRODUCT_ID_PARAM,
          'sort',
        ] as NavigationTreeProps['excludeUrlParams'],
      }}
    />
  );
};
